import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useCallback, useEffect } from 'react';
import { Dialog } from '@headlessui/react';
import { useSpring, animated, config } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { ModalOverlay } from '..';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AnimatedDrawer = animated(Dialog);
export function DrawerLayout(_ref) {
  var isOpen = _ref.isOpen,
      children = _ref.children,
      position = _ref.position,
      styles = _ref.styles,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'tertiary' : _ref$variant,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 400 : _ref$width,
      onClose = _ref.onClose;
  useEffect(function () {
    // 👇 add class to body element
    if (isOpen) {
      document.body.classList.add('dialog-open');
    } else {
      document.body.classList.remove('dialog-open');
    }
  }, [isOpen]);
  var drawerWidth = width;

  var _useSpring = useSpring(function () {
    return {
      x: width
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      x = _useSpring2[0].x,
      api = _useSpring2[1];

  var openDrawer = useCallback(function (_ref2) {
    var canceled = _ref2.canceled;
    // when cancel is true, it means that the user passed the upwards threshold
    // so we change the spring config to create a nice wobbly effect
    api.start({
      x: 0,
      immediate: false,
      config: canceled ? config.wobbly : config.stiff
    });
  }, [api]);
  var closeDrawer = useCallback(function () {
    var velocity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    api.start({
      x: width,
      immediate: false,
      config: _objectSpread(_objectSpread({}, config.stiff), {}, {
        velocity: velocity
      })
    }); //eslint-disable-next-line @typescript-eslint/ban-types
    //eslint-disable-next-line no-restricted-globals

    close();
  }, [api, width]);
  useEffect(function () {
    if (isOpen) {
      openDrawer({
        canceled: false
      });
    }
  }, [isOpen, openDrawer]);
  var display = x.to(function (px) {
    return px < width ? 'flex' : 'none';
  });
  var bindDrag = useDrag(function (_ref3) {
    var last = _ref3.last,
        _ref3$velocity = _slicedToArray(_ref3.velocity, 1),
        vx = _ref3$velocity[0],
        _ref3$movement = _slicedToArray(_ref3.movement, 1),
        mx = _ref3$movement[0],
        _ref3$direction = _slicedToArray(_ref3.direction, 1),
        xDir = _ref3$direction[0],
        canceled = _ref3.canceled;

    // when the user releases the sheet, we check whether it passed
    // the threshold for it to close, or if we reset it to its open positino
    if (last) {
      mx > width * 0.5 || vx > 0.5 && xDir > 0 ? closeDrawer(vx) : openDrawer({
        canceled: canceled
      });
    } // when the user keeps dragging, we just move the sheet according to
    // the cursor position
    else api.start({
      x: mx,
      immediate: true
    });
  }, {
    from: function from() {
      return [x.get(), 0];
    }
  });
  return isOpen ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ModalOverlay, {
      show: isOpen,
      onClick: onClose
    }), /*#__PURE__*/_jsx(StyledDrawer, _objectSpread(_objectSpread({
      variant: variant,
      open: isOpen,
      onClose: onClose,
      position: position
    }, bindDrag()), {}, {
      style: {
        width: drawerWidth,
        display: display,
        x: x
      },
      children: children
    }))]
  }) : null;
}
var commonStyle = {
  "top": "32.667%",
  "maxWidth": "26rem"
};

var StyledDrawer = /*#__PURE__*/_styled(AnimatedDrawer).withConfig({
  displayName: "drawer-layout__StyledDrawer",
  componentId: "sc-1om2k9v-0"
})(["", " ", ";", " ", ";> div:nth-child(2){", " > div:nth-child(2){", "}}"], function (_ref4) {
  var variant = _ref4.variant;
  return {
    primary: commonStyle,
    secondary: [{
      "height": "50%",
      "overflowY": "auto"
    }, commonStyle],
    tertiary: {
      "maxWidth": "26rem"
    }
  }[variant];
}, {
  "position": "fixed",
  "top": "0px",
  "zIndex": "160",
  "height": "100vh",
  "maxWidth": "none",
  "touchAction": "none",
  "alignItems": "center"
}, function (_ref5) {
  var position = _ref5.position;
  return position === 'left' ? {
    "left": "0px"
  } : {
    "right": "0px"
  };
}, {
  "display": "flex",
  "width": "100vw",
  "flexDirection": "column",
  "overflowY": "auto",
  "borderTopLeftRadius": "1.5rem",
  "borderTopRightRadius": "1.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "@media (min-width: 640px)": {
    "bottom": "0px"
  },
  "@media (min-width: 768px)": {
    "height": "100%"
  },
  "@media (min-width: 25.75rem)": {
    "bottom": "0px"
  }
}, {
  "@media (min-width: 768px)": {
    "height": "100%",
    "paddingLeft": "32px",
    "paddingRight": "32px"
  }
}, {
  "borderRadius": "0px",
  "backgroundImage": "none",
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

export default DrawerLayout;